import './topBarStyle.css'
export default function TopBar ()
{
    return (
        <div className="topbar-container">
            <span className='faminto-text-logo'>FAMINTO</span>
            
        </div>
    )
}